<template>
    <div>
        <LoadingPage v-if="isLoadPage" />
        <b-card no-body class="bg-secondary border-0 pt-6">
            <b-card-header class="pb-3">
                <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                        <router-link to="/auth/home">
                        <i class="ni ni-bold-left text-primary"></i>
                        </router-link>
                    </div>
                    <div class="text-primary h3 mb-0 flex-grow-1">
                        รายงานการวิ่งรถ
                    </div>
                </div>
            </b-card-header>
        </b-card>
        <b-container class="py-3 py-lg-4 pt-lg-3">
            <b-row class="justify-content-center">
                <b-col lg="6" md="8" sm="12">
                    <b-card no-body class="mx-3 card-search">
                        <b-card-body>
                            <b-row>
                                <b-col cols="12" class="d-flex align-items-center">
                                    <div class="h4 text-muted">
                                        เลือกวันที่ต้องการค้นหา
                                    </div>
                                </b-col>
                                <b-col cols="6">
                                    <b-form-group 
                                        label="วันที่เริ่ม"
                                        label-for="input-date-start"
                                    >
                                        <b-form-input
                                            id="input-date-start"
                                            type="date"
                                            v-model="search.dateStart"
                                        >
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="6">
                                    <b-form-group 
                                        label="วันที่เริ่มสิ้นสุด"
                                        label-for="input-date-end"
                                    >
                                        <b-form-input
                                            id="input-date-end"
                                            type="date"
                                            v-model="search.dateEnd"
                                        >
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12">
                                    <b-button
                                        variant="primary"
                                        block
                                        @click="searchDate()"
                                    >
                                        ค้นหา
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-card>
                    <b-card no-body class="border-0 card-report-job">
                        <b-card-header class="bg-transparent pt-6 pb-2 px-4 border-0">
                            <div
                                class="d-flex justify-content-between align-items-center"
                            >
                                <div class="d-flex flex-column">
                                    <h3 class="mb-0">งานที่วิ่ง</h3>
                                    <span class="h5 text-muted">ทั้งหมด {{ pagination.totalRows }} รอบ</span>
                                </div>
                                <b-button 
                                    size="sm" 
                                    pill 
                                    variant="outline-info" 
                                    class="d-flex align-items-center"
                                    @click="getDownloadPdf()"
                                >
                                    ดาวน์โหลด PDF <b-icon icon="file-earmark"></b-icon>
                                </b-button>
                            </div>
                        </b-card-header>
                        <b-card-body>
                            <b-row class="text-center">
                                <b-col cols="12" class="my-5">
                                    <TableReportJobDriver 
                                        ref="report" 
                                        :search="search"
                                        :pagination="pagination"
                                    />
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import TableReportJobDriver from '@/components/Job/TableReportJobDriver.vue';
import downloadLink from "@/util/downloadLink.js"

export default {
    components:{
        TableReportJobDriver
    },
    data() {
        return {
            downloadLink,
            isLoadPage: false,
            search:{
                dateStart: null,
                dateEnd: null
            },
            pagination: {
                currentPage: 1,
                perPage: 10,
                totalRows: 0,
            },
        };
    },
    methods: {
        searchDate(){
            this.$refs.report.getReportJobDriver();
        },
        async getDownloadPdf(){
            try{
                const token =  localStorage.getItem("token");

                fetch(`${process.env.VUE_APP_BASE_URL}/jobs/jobs-pdf`, { 
                    headers: new Headers({
                        'Authorization': `Bearer ${token}`
                    }), 
                }).then(x => x.blob()).then(blob => {
                    this.downloadLink(blob, 'report.pdf')
                })
                
            }catch(error){
                console.log(error, 'error')
            }
        }
    }
};
</script>
  